import { useNavigate } from "react-router-dom";
import { useFounderAuth } from "../../context/FounderAuthContext";
import {
  FOUNDER_NAV_SECTIONS,
  buildFounderSectionHubPath,
} from "../../founder/founderNavigation";

type FounderMainMenuProps = {
  selectedSectionId: string | null;
  mobileOpen: boolean;
  onCloseMobile: () => void;
};

function FounderLogoutIcon() {
  return (
    <svg aria-hidden="true" className="oac-founder-main-menu__logout-icon" fill="none" viewBox="0 0 24 24">
      <path
        d="M12 4v5.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.25"
      />
      <path
        d="M7.05 7.05a6.95 6.95 0 1 0 9.9 0"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

export function FounderMainMenu({
  selectedSectionId,
  mobileOpen,
  onCloseMobile,
}: FounderMainMenuProps) {
  const navigate = useNavigate();
  const { logout } = useFounderAuth();

  function handleSectionSelect(sectionId: string) {
    navigate(buildFounderSectionHubPath(sectionId));
    onCloseMobile();
  }

  async function handleSignOut() {
    await logout();
    navigate("/founder/log-in", { replace: true });
    onCloseMobile();
  }

  const panelClassName = [
    "oac-founder-main-menu",
    mobileOpen ? "oac-founder-main-menu--mobile-open" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <aside aria-label="Founder main menu" className={panelClassName}>
      <ul className="oac-founder-main-menu__list">
        {FOUNDER_NAV_SECTIONS.map((section) => {
          const isSelected = selectedSectionId === section.id;
          const buttonClassName = [
            "oac-founder-main-menu__item",
            isSelected
              ? "oac-founder-main-menu__item--selected"
              : "oac-founder-main-menu__item--inactive",
          ].join(" ");

          return (
            <li key={section.id} className="oac-founder-main-menu__row">
              <button
                className={buttonClassName}
                onClick={() => handleSectionSelect(section.id)}
                type="button"
              >
                {section.label}
              </button>
            </li>
          );
        })}
      </ul>

      <div className="oac-founder-main-menu__footer">
        <button
          aria-label="Sign out"
          className="oac-founder-main-menu__logout"
          onClick={handleSignOut}
          title="Sign out"
          type="button"
        >
          <FounderLogoutIcon />
        </button>
      </div>

      <button
        aria-label="Go to overview"
        className="oac-founder-main-menu__home-link"
        onClick={() => {
          navigate(buildFounderSectionHubPath("overview"));
          onCloseMobile();
        }}
        type="button"
      >
        Overview
      </button>
    </aside>
  );
}
